<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Receipt Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="receipt_date_from"/> ~ <CustomDatePicker v-model="receipt_date_to"/></span>

				<span class="int_type_no_border mgr_5"> <PartnerSelect v-model="bill_to_code" ph="Bill To" :showName="false" @set-partner="setPartner" /> </span>

				<span class="int_type mgr_5">
					<input type="text" v-model.trim="reason" placeholder="Enter Reason" autocomplete="off" @keyup.enter="search()" />
				</span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<!-- <div style="height:780px;"> -->

		<div class="fixed-table-container" style="height:720px;">
			<div class="table-wrapper">
				<table class="list_tbl tbl_pointer">
					<thead>
						<tr>
							<th width="2%"></th>
							<!-- <th width="7%"><div class="th-text">Receipt No</div></th> -->
							<th width="4%"><div class="th-text">Bill To</div></th>
							<th><div class="th-text">Name</div></th>
							<th width="5%"><div class="th-text">Inv. Date</div></th>
							<th width="6%"><div class="th-text">Inv. No</div></th>

							<th width="7%"><div class="th-text">Receiver</div></th>
							<th width="5%"><div class="th-text">R. / P. Date</div></th>

							<th width="7%"><div class="th-text">Payment Term</div></th>
							<th width="5%"><div class="th-text">Inv. Amt.</div></th>
							<th width="5%"><div class="th-text">Inv. Pay Amt.</div></th>

							<th width="5%"><div class="th-text">Pay Amt.</div></th>
							<!-- <th width="10%">Remark</th> -->
							<th width="10%"><div class="th-text">Check No(s)</div></th>
							<th width="3%"><div class="th-text">R</div></th>
							<th width="18%"><div class="th-text">Reverse Reason</div></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(receipt, i) in receipts" v-bind:key="i" v-bind:class="{ on: receipt.receipt_no == selectedReceipt.receipt_no }" @click="selectRow(receipt)">
							<!-- <td class="al_center" :rowspan="calRowSpanCount(i, receipt.invoice_count)" v-if="!i ? true : receipts[i - 1].receipt_no == receipts[i].receipt_no ? '' : true"> -->
							<td class="al_center" :rowspan="receipt.invoice_count" v-if="!i ? true : receipts[i - 1].receipt_no == receipts[i].receipt_no ? '' : true">
								<input type="radio" :disabled="receipt.reverse_yn == 'Y'" v-model="selectedReceipt.receipt_no" :value="receipt.receipt_no" />
							</td>
							<td class="al_left">
								<!-- {{ receipt.bill_to_code }} -->
								<a href="javascript:;" @click="gotoArHistory(receipt.bill_to_code, receipt.bill_to_name)">{{ receipt.bill_to_code }}</a>
							</td>
							<td class="al_left truncate">{{ receipt.bill_to_name }}</td>
							<td class="al_left">{{ receipt.invoice_date }}</td>
							<td class="al_left">{{ receipt.invoice_dn }}</td>
							<!-- <td class="al_left" :rowspan="receipt.invoice_count" v-if="!i ? true : receipts[i - 1].receipt_no == receipts[i].receipt_no ? '' : true">{{ receipt.receipt_dn }}</td> -->

							<td class="al_left" :rowspan="receipt.invoice_count" v-if="!i ? true : receipts[i - 1].receipt_no == receipts[i].receipt_no ? '' : true">
								{{ receipt.receiver_id }}
							</td>
							<td class="al_left" :rowspan="receipt.invoice_count" v-if="!i ? true : receipts[i - 1].receipt_no == receipts[i].receipt_no ? '' : true">
								{{ receipt.valid_receipt_date }}
							</td>

							<td class="al_left">{{ receipt.payment_term_name }}</td>

							<td class="al_right">{{ receipt.invoice_amount | toCurrency }}</td>
							<td class="al_right">{{ receipt.paid_amount | toCurrency }}</td>

							<td class="al_right" :rowspan="receipt.invoice_count" v-if="!i ? true : receipts[i - 1].receipt_no == receipts[i].receipt_no ? '' : true">
								{{ receipt.total_amount | toCurrency }}
							</td>

							<td class="al_left" :rowspan="receipt.invoice_count" v-if="!i ? true : receipts[i - 1].receipt_no == receipts[i].receipt_no ? '' : true">{{ receipt.receipt_info }}</td>
							<td class="al_center" :rowspan="receipt.invoice_count" v-if="!i ? true : receipts[i - 1].receipt_no == receipts[i].receipt_no ? '' : true">
								<span :style="receipt.reverse_yn == 'Y' ? 'font-weight:bold;color:red;' : ''">{{ receipt.reverse_yn }}</span>
							</td>
							<td class="al_left" :rowspan="receipt.invoice_count" v-if="!i ? true : receipts[i - 1].receipt_no == receipts[i].receipt_no ? '' : true">
								{{ receipt.reverse_reason }}
							</td>
						</tr>

						<tr>
							<td colspan="8" class="al_right"><font color="red">Listed Total</font></td>

							<td class="al_right">
								<font color="red">{{ invoice_amount_sum | toCurrency }}</font>
							</td>
							<td class="al_right">
								<font color="red">{{ paic_amount_sum | toCurrency }}</font>
							</td>
							<td class="al_right">
								<font color="red">{{ paic_amount_sum | toCurrency }}</font>
							</td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
					</tbody>
				</table>
				<!-- </div> -->
				<!-- </div> -->
			</div>
		</div>

		<div style="text-align:right;padding-right:10px;">Total Invoice Count : {{ list_count | commaSeparated }} (Max {{ max_count }} receipts)</div>

		<div class="bottom_bt_box" style="padding-top:10px;">
			<ul>
				<a v-if="modifiable" href="javascript:;" class="gray_bt" @click="reverse()">Reverse Process</a>
			</ul>
		</div>

		<!-- <Modal @close="closeModal" v-if="showModal" :draggable="false">
			<template slot="title">Process Payment</template>
			<template slot="body">
				<ReceiptPopup :toReceiveInvoices="toReceiveInvoices" :totalReceiptAmount="pay_amount_sum" v-on:close="closeModal()" @receipt-call-back="receiptCallBack" />
			</template>
		</Modal> -->

		<Modal @close="closeModal" v-if="showModal" :draggable="false">
			<template slot="title">Confirm</template>
			<template slot="body">
				<div style="width:400px; height:150px;">
					<table class="view_tbl" border="0">
						<colgroup>
							<col style="width:120px;" />
							<col style="" />
						</colgroup>
						<tbody>
							<tr>
								<th>Select Reason</th>
								<td>
									<select class="tbl_select full_int" v-model="new_reason">
										<option :value="null">Select or Write yourself</option>
										<option value="Accident ">Accident</option>
										<option value="Change a method type ">Change a method type</option>
									</select>
								</td>
							</tr>
							<tr>
								<th>Write Reason</th>
								<td><input type="text" v-model.trim="new_reason_input" :disabled="new_reason" class="tbl_int full_int" @focus="$event.target.select()" /></td>
							</tr>
							<!-- <tr>
								<th><font color="red">Previous Address</font></th>
								<td>
									<select class="tbl_select full_int" v-model="selected_prev_address_index" @change="selectPrevAddress()">
										<option value="-1">Select !!!</option>
										<option v-for="(addr, index) in prev_ship_to_address_list" v-bind:value="index" v-bind:key="index"
											>{{ addr.ship_to_name }}, {{ addr.address_detail }}, {{ addr.address_city }}, {{ addr.address_state }} {{ addr.address_zipcode }}</option
										>
									</select>
								</td>
							</tr> -->
						</tbody>
					</table>

					<div class="popup_bottom">
						<a href="javascript:;" @click="reverseConfirm()" class="search_bt mgr_15">OK</a>
						<a href="javascript:;" @click="closeModal()" class="gray_bt">Cancel</a>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectReceiptReverseList, apiReverseReceipt } from '@/api/receipt/index.js';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
// import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import { daysAgo, today } from '@/utils/date.js';
// import ReceiptPopup from '@/components/common/ReceiptPopup';
import Modal from '@/components/common/Modal';
import '@/assets/css/table_box.css';

export default {
	data: function() {
		return {
			backUri: '/',

			receipt_date_from: daysAgo(180),
			receipt_date_to: today(),
			//receipt_date_from: null,
			//receipt_date_to: null,

			allSelected: false,

			receipts: [],
			selectedReceipt: {},

			bill_to_code: null,
			reason: null,

			list_count: null,
			max_count: 1000,

			modalName: '',
			showModal: false,

			new_reason: null,
			new_reason_input: null,

			default_ago_days: 180,
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		invoice_amount_sum() {
			var invoice_amount_sum = 0;
			this.receipts.forEach(r => {
				invoice_amount_sum += r.invoice_amount;
			});
			return invoice_amount_sum;
		},
		paic_amount_sum() {
			var paic_amount_sum = 0;
			this.receipts.forEach(r => {
				paic_amount_sum += r.paid_amount;
			});
			return paic_amount_sum;
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		CustomDatePicker,
		// Paging,
		// CodeSelect,
		PartnerSelect,
		// ReceiptPopup,
		Modal,
	},
	methods: {
		calRowSpanCount(index, invoice_count) {
			console.log(index);
			//return index + invoice_count > this.max_count ? Math.max(index + invoice_count - this.max_count - 1, 1) : invoice_count;
			return invoice_count;
		},
		gotoArHistory(partner_code, partner_name) {
			this.$router.push({ name: 'arHistory', query: { backUri: this.$route.fullPath, bill_to_code: partner_code, bill_to_name: partner_name, date_type_is_invoice: '2' } });
		},
		setPartner(partner) {
			this.bill_to_code = partner.code;
			this.search();
		},
		selectRow(receipt) {
			this.selectedReceipt = receipt;
		},
		reverse() {
			if (this.selectedReceipt.reverse_yn == 'Y') {
				this.$toast.error('Already Reversed Receipt');
				return;
			}
			if (!this.selectedReceipt.receipt_no) {
				this.$toast.error('Nothing to process');
				return;
			}

			this.new_reason = null;
			this.new_reason_input = null;
			this.showModal = true;

			// this.$alertify.promptWithTitle('Confirm', 'Are you sure to reverse the receipt? Please enter the reason.', '', (evt, value) => {
			// 	this.reverseConfirm(value);
			// });
		},
		closeModal() {
			this.showModal = false;
		},
		//async reverseConfirm(reason) {
		async reverseConfirm() {
			var reason;
			if (this.new_reason) reason = this.new_reason;
			else reason = this.new_reason_input;
			//console.log(reason);
			this.showModal = false;

			const { data } = await apiReverseReceipt({
				receipt_no: this.selectedReceipt.receipt_no,
				reason: reason,
			});

			if (data.result) {
				this.$toast.success('Receipt reversed successfully');
				this.search();
			} else {
				this.$toast.error(data.msg);
			}
		},
		reset() {
			this.receipt_date_from = daysAgo(this.default_ago_days);
			this.receipt_date_to = today();

			this.bill_to_code = null;
			this.keyword = null;
		},
		search() {
			this.selectReceipts();
		},
		async selectReceipts() {
			this.selectedReceipt = {};

			const { data } = await apiSelectReceiptReverseList({
				receipt_date_from: this.receipt_date_from,
				receipt_date_to: this.receipt_date_to,
				bill_to_code: this.bill_to_code,
				reason: this.reason,

				max_count: this.max_count,
			});
			//console.log(data);
			this.receipts = data.receiptList;
			this.list_count = this.receipts.length;
			//console.log(this.receipts);

			// var uri = '/receipt/ar_main?page_no=' + this.page_no;
			// if (this.outstanding_yn) uri += '&outstanding_yn=' + this.outstanding_yn;
			// if (this.invoice_date_from) uri += '&invoice_date_from=' + this.invoice_date_from;
			// if (this.invoice_date_to) uri += '&invoice_date_to=' + this.invoice_date_to;
			// if (this.sales_group_code) uri += '&sales_group_code=' + this.sales_group_code;
			// if (this.bill_to_code) uri += '&bill_to_code=' + this.bill_to_code;
			// if (this.cart_yn) uri += '&cart_yn=' + this.cart_yn;
			// this.$router.replace(uri).catch(err => err);
		},
		gotoPartner(code) {
			this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, code: code } });
		},
		async init() {
			// if (this.$route.query.outstanding_yn) this.outstanding_yn = this.$route.query.outstanding_yn;
			// if (this.$route.query.invoice_date_from) this.invoice_date_from = this.$route.query.invoice_date_from;
			// if (this.$route.query.invoice_date_to) this.invoice_date_to = this.$route.query.invoice_date_to;
			// if (this.$route.query.sales_group_code) this.sales_group_code = this.$route.query.sales_group_code;
			// if (this.$route.query.bill_to_code) this.bill_to_code = this.$route.query.bill_to_code;
			// if (this.$route.query.cart_yn) this.cart_yn = this.$route.query.cart_yn;
			await this.selectReceipts();
		},
	},
	created() {
		//this.$store.sideIndex = 3;
		this.$store.commit('setSideIndex', 5);
		//this.$store.selectedMenu = 'nav_li_6';
		this.$store.commit('setSelectedMenu', 'nav_li_ar_reverse');
		this.$store.commit('setSubTitle', 'Accounting -> Payment Reverse');

		if (this.user.company_id == 'hairplus') this.default_ago_days = 548;
		else this.default_ago_days = 180;

		this.receipt_date_from = daysAgo(this.default_ago_days);

		this.init();
	},
	mounted() {
		inputSelectOnClick();
		//makeTableResizable();
	},
};
</script>

<style></style>
